import {
  SIGNALTEK10G_TESTS_LIST,
  TESTS_CLEAR_SMART_FLAG_STATUSES,
  TEST_SIGNALTEK_GET
} from "../actions/testsActions";
const TESTS_LIST_SUCCESS = "TESTS_LIST_SUCCESS";
const TESTS_LIST_FAIL = "TESTS_LIST_FAIL";
const TESTS_METADATA_STANDARDS_SUCCESS = "TESTS_METADATA_STANDARDS_SUCCESS";
const TESTS_METADATA_STANDARDS_FAIL = "TESTS_METADATA_STANDARDS_FAIL";
const FIBER_TESTS_METADATA_STANDARDS_SUCCESS =
  "FIBER_TESTS_METADATA_STANDARDS_SUCCESS";
const FIBER_TESTS_METADATA_STANDARDS_FAIL =
  "FIBER_TESTS_METADATA_STANDARDS_FAIL";
const TESTS_SAVE_SUCCESS = "TESTS_SAVE_SUCCESS";
const TESTS_FIBER_SAVE_SUCCESS = "TESTS_FIBER_SAVE_SUCCESS";
const TESTS_SAVE_FAIL = "TESTS_SAVE_FAIL";
const TESTS_FIBER_SAVE_FAIL = "TESTS_FIBER_SAVE_FAIL";
const TESTS_RESET = "TESTS_RESET";
const JOB_TESTS_RESET = "JOB_TESTS_RESET";
const TESTS_SELECTED = "TESTS_SELECTED";
const TESTS_MOVE_SUCCESS = "TESTS_MOVE_SUCCESS";
const TESTS_MOVE_FAIL = "TESTS_MOVE_FAIL";
const TESTS_DELETE_SUCCESS = "TESTS_DELETE_SUCCESS";
const TESTS_DELETE_FAIL = "TESTS_DELETE_FAIL";
const TEST_GET_SUCCESS = "TEST_GET_SUCCESS";
const TEST_GET_FAIL = "TEST_GET_FAIL";
const FIBER_TEST_GET_SUCCESS = "FIBER_TEST_GET_SUCCESS";
const FIBER_TEST_GET_FAIL = "FIBER_TEST_GET_FAIL";
const FIBER_TEST_UPDATE_SUCCESS = "FIBER_TEST_UPDATE_SUCCESS";
const FIBER_TEST_UPDATE_FAIL = "FIBER_TEST_UPDATE_FAIL";
const TEST_UPDATE_SUCCESS = "TEST_UPDATE_SUCCESS";
const TEST_UPDATE_FAIL = "TEST_UPDATE_FAIL";
const TEST_RECERT_SUCCESS = "TEST_RECERT_SUCCESS";
const TEST_RECERT_FAIL = "TEST_RECERT_FAIL";
const TESTS_LIST_SAVE_PREFERENCES = "TESTS_LIST_SAVE_PREFERENCES";
const TESTS_LIST_COLUMN_PRESETS_LOADED = "TESTS_LIST_COLUMN_PRESETS_LOADED";
const TESTS_LIST_COLUMN_PRESET_SELECTED = "TESTS_LIST_COLUMN_PRESET_SELECTED";
const TESTS_GENERATE_REPORT_SUCCESS = "TESTS_GENERATE_REPORT_SUCCESS";
const TESTS_GENERATE_REPORT_FAIL = "TESTS_GENERATE_REPORT_FAIL";
const JOB_TEST_ATTACHMENTS_SUCCESS = "JOB_TEST_ATTACHMENTS_SUCCESS";
const JOB_TEST_ATTACHMENTS_FAIL = "JOB_TEST_ATTACHMENTS_FAIL";
const CLEAR_ATTACHMENTS = "CLEAR_ATTACHMENTS";
const CLEAR_ERRORS_VALUES = "CLEAR_ERRORS_VALUES";
const SUCCESS = "_SUCCESS";
const FAIL = "_FAIL";
const TESTS_SIGNALTEK_SAVE_SUCCESS = "TESTS_SIGNALTEK_SAVE_SUCCESS";
const TESTS_SIGNALTEK_SAVE_FAIL = "TESTS_SIGNALTEK_SAVE_FAIL";
const JOB_SEARCH_FILTER = "JOB_SEARCH_FILTER";
const JOB_USER_PREFERENCE_SUCCESS = "JOB_USER_PREFERENCE_SUCCESS";
const JOB_USER_PREFERENCE_FAIL = "JOB_USER_PREFERENCE_FAIL";
const JOB_USER_PREFERENCE_SAVE_SUCCESS = "JOB_USER_PREFERENCE_SAVE_SUCCESS";
const JOB_USER_PREFERENCE_SAVE_FAIL = "JOB_USER_PREFERENCE_SAVE_FAIL";

export const defaultTestsState = {
  standards: null,
  testsCreated: null,
  testUpdated: null,
  testRecerted: true,
  errors: null,
  filters: null,
  tests: null,
  test: null,
  signaltekTest: null,
  selected: null,
  preferences: null,
  preferencesSaved: true,
  columnPreset: "LanTEKIV",
  columnPresets: null,
  jobid: null,
  attachments: null,
  fiberStandards: null,
  testListOf10g: null,
  jobSearchFilter: null,
  searchParams: [],
  jobSearchFilterSaved: true,
  testNames: []
};

const clearSmartFlagStatus = test => {
  if (!test) {
    return test;
  }

  return {
    ...test,
    smartflagstatus: null,
    smartFlagStatus: null,
    SmartFlagStatus: null
  };
};

const clearSmartFlagStatuses = tests => {
  if (!tests) {
    return tests;
  }

  if (Array.isArray(tests)) {
    return tests.map(clearSmartFlagStatus);
  }

  if (Array.isArray(tests.data)) {
    return {
      ...tests,
      data: tests.data.map(clearSmartFlagStatus)
    };
  }

  return tests;
};

export default (state = defaultTestsState, action) => {
  switch (action.type) {
    case TESTS_LIST_SUCCESS:
      return {
        ...state,
        tests: action.payload.data,
        filters: action.meta.previousAction.payload.request.data,
        jobid: action.meta.previousAction.payload.request.jobid
      };
    case TESTS_LIST_FAIL:
      return {
        ...state,
        tests: null,
        filters: null
      };
    case TESTS_METADATA_STANDARDS_SUCCESS:
      return {
        ...state,
        standards: action.payload.data
      };
    case TESTS_METADATA_STANDARDS_FAIL:
      return {
        ...state
      };
    case FIBER_TESTS_METADATA_STANDARDS_SUCCESS:
      return {
        ...state,
        fiberStandards: action.payload.data
      };
    case FIBER_TESTS_METADATA_STANDARDS_FAIL:
      return {
        ...state
      };
    case TESTS_FIBER_SAVE_SUCCESS:
      return {
        ...state,
        testsCreated: action.payload.data.success,
        errors: action.payload.data.errors
      };
    case TESTS_SAVE_SUCCESS:
      return {
        ...state,
        testsCreated: action.payload.data.success,
        errors: action.payload.data.errors
      };
    case TESTS_SAVE_FAIL:
      return {
        ...state
      };
    case TESTS_FIBER_SAVE_FAIL:
      return {
        ...state
      };
    case TESTS_RESET:
      return {
        ...state,
        testsCreated: false,
        errors: null,
        test: null,
        signaltekTest: null
      };
    case JOB_TESTS_RESET:
      return {
        ...state,
        tests: null,
        testsCreated: false,
        errors: null,
        testListOf10g: null
      };
    case TESTS_SELECTED:
      return {
        ...state,
        selected: action.data
      };
    case TESTS_CLEAR_SMART_FLAG_STATUSES:
      return {
        ...state,
        tests: clearSmartFlagStatuses(state.tests),
        testListOf10g: clearSmartFlagStatuses(state.testListOf10g),
        test: clearSmartFlagStatus(state.test),
        signaltekTest: clearSmartFlagStatus(state.signaltekTest)
      };
    case TESTS_MOVE_SUCCESS:
      return {
        ...state
      };
    case TESTS_MOVE_FAIL:
      return {
        ...state
      };
    case TESTS_DELETE_SUCCESS:
      return {
        ...state
      };
    case TESTS_DELETE_FAIL:
      return {
        ...state
      };
    case TEST_GET_SUCCESS:
      return {
        ...state,
        test: action.payload.data
      };
    case TEST_GET_FAIL:
      return {
        ...state
      };
    case FIBER_TEST_GET_SUCCESS:
      return {
        ...state,
        fibertest: action.payload.data
      };
    case FIBER_TEST_GET_FAIL:
      return {
        ...state
      };
    case TEST_UPDATE_SUCCESS:
      return {
        ...state,
        testUpdated: action.payload.data.success,
        errors: action.payload.data.errors,
        testNames: action.payload.data.testName
      };
    case TEST_UPDATE_FAIL:
      return {
        ...state
      };
    case FIBER_TEST_UPDATE_SUCCESS:
      return {
        ...state,
        testUpdated: action.payload.data.success,
        errors: action.payload.data.errors,
        testNames: action.payload.data.testName
      };
    case FIBER_TEST_UPDATE_FAIL:
      return {
        ...state
      };
    case TEST_RECERT_SUCCESS:
      return {
        ...state,
        testRecerted: action.payload.data.success,
        errors: action.payload.data.errors
      };
    case TEST_RECERT_FAIL:
      return {
        ...state
      };
    case TESTS_LIST_SAVE_PREFERENCES: {
      const { pager, columns, preferencesSaved, visibleColumns } = action.data;
      //Save Preference In Local Storage
      if (preferencesSaved) {
        localStorage.setItem(
          "tests_prefernces",
          JSON.stringify({
            pager,
            columns
          })
        );
      }

      //
      return {
        ...state,
        preferences: {
          pager,
          columns
        },
        columnPresets: {
          ...state.columnPresets,
          [state.columnPreset]: visibleColumns
        },
        preferencesSaved
      };
    }
    case TESTS_LIST_COLUMN_PRESETS_LOADED: {
      const { presets } = action.data;

      return {
        ...state,
        columnPresets: presets
      };
    }

    case TESTS_LIST_COLUMN_PRESET_SELECTED: {
      const { pager, columns, preferencesSaved , preset } = action.data;

      if (preferencesSaved) {
        localStorage.setItem(
          "tests_prefernces",
          JSON.stringify({
            pager,
            columns
          })
        );
      }

      return {
        ...state,
        preferences: {
          columns: columns,
          pager
        },
        columnPreset: preset
      };
    }
    case TESTS_GENERATE_REPORT_SUCCESS: {
      return {
        ...state
      };
    }
    case TESTS_GENERATE_REPORT_FAIL: {
      return {
        ...state
      };
    }
    case JOB_TEST_ATTACHMENTS_SUCCESS: {
      return {
        ...state,
        attachments: action.payload.data
      };
    }
    case JOB_TEST_ATTACHMENTS_FAIL: {
      return {
        ...state
      };
    }
    case CLEAR_ATTACHMENTS: {
      return {
        ...state,
        attachments: null
      };
    }
    case CLEAR_ERRORS_VALUES: {
      return {
        ...state,
        errors: null
      };
    }
    case SIGNALTEK10G_TESTS_LIST + SUCCESS: {
      return {
        ...state,
        testListOf10g: action.payload.data,
        filters: action.meta.previousAction.payload.request.data,
        jobid: action.meta.previousAction.payload.request.jobid
      };
    }
    case SIGNALTEK10G_TESTS_LIST + FAIL: {
      return {
        ...state,
        testListOf10g: null,
        filters: null
      };
    }
    case TESTS_SIGNALTEK_SAVE_SUCCESS:
      return {
        ...state,
        testsCreated: action.payload.data.success,
        errors: action.payload.data.errors
      };
    case TESTS_SIGNALTEK_SAVE_FAIL:
      return {
        ...state
      };
    case TEST_SIGNALTEK_GET + SUCCESS: {
      return {
        ...state,
        signaltekTest: action.payload.data
      };
    }
    case TEST_SIGNALTEK_GET + FAIL: {
      return {
        ...state
      };
    }
    case JOB_SEARCH_FILTER: {
      const { searchFilter, searchParams, jobSearchFilterSaved } = action.data;
      //Save Preference In Local Storage
      if (jobSearchFilterSaved) {
        let tempSearch = [...searchParams];
        sessionStorage.setItem(
          "JOB_SEARCH_FILTER",
          JSON.stringify({
            ...searchFilter
          })
        );
        sessionStorage.setItem(
          "JOB_SEARCH_PARAMS",
          JSON.stringify({
            tempSearch
          })
        );
      }
      //
      return {
        ...state,
        jobSearchFilter: searchFilter,
        searchParams: [...searchParams],
        jobSearchFilterSaved
      };
    }
    case JOB_USER_PREFERENCE_SUCCESS:
      return {
        ...state,
        userPreference: action.payload.data
      };
    case JOB_USER_PREFERENCE_FAIL:
      return {
        ...state
      };
    case JOB_USER_PREFERENCE_SAVE_SUCCESS:
      return {
        ...state,
        userPref: action.payload.data.success,
        errors: action.payload.data.errors
      };
    case JOB_USER_PREFERENCE_SAVE_FAIL:
      return {
        ...state
      };
    default:
      return state;
  }
};
